class Logger{

    debug(msg: any,TAG:string = 'DEBUG'){
        console.log(`${new Date().toISOString()}:${TAG}:${this.refineMsg(msg)}`)
    }

    info(msg: any,TAG:string = 'INFO'){
        console.log(`${new Date().toISOString()}:${TAG}:${this.refineMsg(msg)}`)
    }

    warn(msg: any,TAG:string = 'WARN'){
        console.warn(`${new Date().toISOString()}:${TAG}:${this.refineMsg(msg)}`)
    }

    err(msg: any,TAG:string = 'ERROR'){
        console.error(`${new Date().toISOString()}:${TAG}:${msg}`)
    }

    private refineMsg(data: any){
        if(typeof(data) == 'object')
         return JSON.stringify(data)
        else
         return data
    }

}

export default new Logger()